/**
 * widgets/registry.registry.tsx — Module Registry widgety (2.1).
 */
import { Globe, Package, Server, Upload, RefreshCw } from 'lucide-react';
import type { WidgetSpec } from './types';
import {
  CatalogPanel,
  PeersPanel,
  RegistryHealthPanel,
  RegistryPublishPanel,
  TreePanel,
} from '../pages/modules/registry/panels';

export const REGISTRY_MODULE_WIDGETS: WidgetSpec[] = [
  {
    id: 'registry.tree',
    title: 'Resource tree',
    module: 'registry',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Server,
    since: '2.1.0',
    component: TreePanel,
  },
  {
    id: 'registry.health',
    title: 'Registry health',
    module: 'registry',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: RefreshCw,
    since: '2.1.0',
    component: RegistryHealthPanel,
  },
  {
    id: 'registry.catalog',
    title: 'Module catalog',
    module: 'registry',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Package,
    since: '2.1.0',
    component: CatalogPanel,
  },
  {
    id: 'registry.peers',
    title: 'Registry peers',
    module: 'registry',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Globe,
    since: '2.1.0',
    component: PeersPanel,
  },
  {
    id: 'registry.publish',
    title: 'Publish modules',
    module: 'registry',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Upload,
    since: '2.1.0',
    component: RegistryPublishPanel,
  },
];
